export class AddQuestionConditionRequest {
    private readonly id_question: number
    private readonly id_answers: number[]

    constructor(id_question: number, answers: number[]) {
        this.id_question = id_question;
        this.id_answers = answers;
    }

}